import { Box, Paper, Typography, Avatar, Stack } from '@mui/material';
import Chip from '@mui/material/Chip';

import { useCallback, useState } from 'react';

import { Loader } from 'common/components/Loader/Loader';
import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import {
	dateFullYearFormat,
	formatAssigneeName,
	scrollProps,
} from 'common/utils/utilFunctions';

import styles from './TestStatusTable.module.scss';

const TestStatusTable = ({ testStatusData }: any) => {
	const [isLoading] = useState<boolean>(false);
	const [toastMessage, setToastMessageLocal] = useState('');
	const [isToastOpen, setIsToastOpen] = useState(false);
	const dateInCorrectFormat: any = (time: string) => {
		const date = new Date(time);
		const formattedDate = date.toLocaleString('en-US', {
			month: '2-digit',
			day: '2-digit',
			year: '2-digit',
		});
		const correctTime = `${formattedDate}`;
		return correctTime;
	};
	const handleToast = useCallback(() => {
		setIsToastOpen(false);
		setToastMessageLocal('');
	}, []);
	const columns: readonly Column[] = [
		{
			id: 'testPlan',
			label: 'Test plan',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<Typography
					component="div"
					className={`${styles['processes-table-process-name']} ${params.testPlan.length}> 30 ? ${styles['processes-table-process-name-wrap']} : ''}`}
				>
					{params?.testPlan ? params?.testPlan : '--'}
				</Typography>
			),
		},
		{
			id: 'testArea',
			label: 'Test area',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testArea ? params?.testArea : '--'}</div>
			),
		},
		{
			id: 'testType',
			label: 'Test type',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testType ? params?.testType : '--'}</div>
			),
		},
		{
			id: 'testPlanId',
			label: 'Test record',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testPlanId ? params?.testPlanId : '--'}</div>
			),
		},
		{
			id: 'tester',
			label: 'Tester',
			disablePadding: false,
			isSortable: true,
			render: (params: any) =>
				params.tester ? (
					<Avatar className={styles['process-table-cell-avatar']}>
						{formatAssigneeName(params.tester)}
					</Avatar>
				) : (
					<div>--</div>
				),
		},
		{
			id: 'testStatus',
			label: 'Test status',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testStatus ? params?.testStatus : '--'}</div>
			),
		},
		{
			id: 'testResults',
			label: 'Test Result',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testResults ? params?.testResults : '--'}</div>
			),
		},
		{
			id: 'committedStartDate',
			label: 'Committed start date',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>
					{params?.committedStartDate
						? dateFullYearFormat(params?.committedStartDate)
						: '--'}
				</div>
			),
		},
		{
			id: 'committedEndDate',
			label: 'Committed end date',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<Stack
					spacing={2}
					direction="row"
					className={styles['process-action-table-content-align']}
				>
					{params?.committedEndDate ? (
						<div
							className={styles['process-action-table-date']}
							data-testid="committed-end-date"
						>
							{dateFullYearFormat(params?.committedEndDate)}{' '}
						</div>
					) : (
						'--'
					)}
					{dateInCorrectFormat(params?.committedEndDate) <
						dateInCorrectFormat(new Date()) &&
						params?.committedEndDate && (
							<span className={styles['process-action-table-chip']}>
								<Chip
									className={styles['processes-table-table-chip-color']}
									label="Overdue"
									size="medium"
									variant="outlined"
									color="error"
								/>
							</span>
						)}
				</Stack>
			),
		},
	];
	return (
		<Box className={styles['processes-table-box']} sx={scrollProps('x-axis')}>
			{testStatusData && testStatusData.length > 0 && !isLoading ? (
				<CommonTable
					id="TestStatusTable"
					rows={testStatusData}
					columns={columns}
					defaultSortKey=""
					tableStyles={{ minWidth: 750, maxHeight: 440 }}
				/>
			) : (
				<div>
					{!isLoading ? (
						<Paper className={styles['processes-table-loading-box']}>
							<Typography data-testid="no-data-found">No data found</Typography>
						</Paper>
					) : (
						<Paper className={styles['processes-table-loading-box']}>
							<Loader show={false} />
						</Paper>
					)}
				</div>
			)}
			<AlertComponent
				open={isToastOpen}
				toastMessage={toastMessage}
				severity="error"
				handleCloseMessage={handleToast}
				vertical="top"
				horizontal="right"
			/>
		</Box>
	);
};
export default TestStatusTable;
